import * as React from "react";

function SvgRichpanel(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="-30 40 365 365"
      {...{ ...props, ref }}
    >
      <path
        data-name="Ellipse 1 copy 3"
        d="M271.185 358H60.262A19.284 19.284 0 0141 338.7V127.305A19.284 19.284 0 0160.262 108h210.923a19.284 19.284 0 0119.263 19.305V338.7a19.284 19.284 0 01-19.263 19.3z"
        fillRule="evenodd"
        fill="#0e5394"
      />
      <path
        data-name="Ellipse 6 copy 3"
        d="M193.9 167.689a7.708 7.708 0 01-15 2.439 14.056 14.056 0 10-12.439 20.521 13.909 13.909 0 007.42-2.148 7.721 7.721 0 011.4-.991q.254-.2.5-.417l.063.142a7.654 7.654 0 116.221 13.985l.074.168a29.583 29.583 0 01-41.084-9.913 57.142 57.142 0 00-31.884 44.9s-1.372 7.62-9.347 7.62a8.931 8.931 0 01-8.971-8.89c0-1.431.373-6.843.98-8.041 4.077-25.987 21.611-44.366 45.329-53.512a29.525 29.525 0 0156.074-9.051l-.028.021a7.56 7.56 0 01.692 3.167zm22.914 135.045a7.728 7.728 0 015.392-14.239 14.073 14.073 0 10-13.368-13.542 7.676 7.676 0 01.162 1.707c.033.214.07.428.112.64l-.154-.016a7.747 7.747 0 01-1 3.092 7.618 7.618 0 01-14.2-4.686l-.182-.019a29.668 29.668 0 0129.108-30.7 57.2 57.2 0 00-22.854-50.122s-5.9-5-1.911-11.923a8.911 8.911 0 0112.168-3.341c1.237.716 5.726 3.745 6.458 4.87 20.417 16.532 27.532 40.941 23.577 66.1a29.609 29.609 0 01-20.217 53.194v-.035a7.517 7.517 0 01-3.092-.98zM87.42 255.548a7.722 7.722 0 019.608 11.8 14.157 14.157 0 00-.193 14.507 13.948 13.948 0 1018.578-19.338 7.718 7.718 0 01-1.554-.715c-.2-.079-.405-.154-.609-.223l.091-.126a7.731 7.731 0 01.582-12.919 7.616 7.616 0 018.393.527l.107-.149a29.716 29.716 0 0111.977 40.615 56.916 56.916 0 0054.738 5.225s7.271-2.619 11.258 4.3a8.952 8.952 0 01-3.2 12.232c-1.236.715-6.1 3.1-7.437 3.17-24.494 9.455-49.144 3.426-68.906-12.587A29.586 29.586 0 0185 257.726l.032.015a7.533 7.533 0 012.388-2.193z"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default React.forwardRef(SvgRichpanel);
